import { z } from 'zod';

export const mediaTypes = ['folder', 'image', 'video', 'audio', 'text', 'uploading'] as const;
export const MediaTypeSchema = z.enum(mediaTypes);
export type MediaType = z.infer<typeof MediaTypeSchema>;

export const MediaTypeSpecificDataSchema = z.discriminatedUnion('kind', [
	z.object({
		kind: z.literal('folder'),
		children: z.array(z.string().uuid()),
	}),
	z.object({
		kind: z.literal('video'),
		videoId: z.string(),
	}),
	z.object({ kind: z.literal('image') }),
	z.object({ kind: z.literal('audio') }),
	z.object({ kind: z.literal('text') }),
	z.object({ kind: z.literal('uploading') }),
]);
export type MediaTypeSpecificData = z.infer<typeof MediaTypeSpecificDataSchema>;

export const MediaNodeBaseSchema = z.object({
	id: z.string().uuid(),
	parentId: z.string().uuid().nullable(),
	kind: MediaTypeSchema,
	mimeType: z.string().optional(),
	filename: z.string(),
	createdAt: z.string(),
	updatedAt: z.string(),
	children: z.array(z.string().uuid()).optional(),
	contentSource: z.enum(['console', 'client']).default('console'),
});

export const MediaNodeSchema = MediaTypeSpecificDataSchema.and(MediaNodeBaseSchema);

export type MediaNode = z.infer<typeof MediaNodeSchema>;

export const BreadcrumbSchema = z.object({
	id: z.string().uuid().nullable(),
	name: z.string(),
});
export type Breadcrumb = z.infer<typeof BreadcrumbSchema>;

export const MediaDirectorySchema = z.object({
	folderId: z.string().uuid().nullable(),
	parentId: z.string().uuid().nullable(),
	breadcrumbs: z.array(BreadcrumbSchema),
	children: z.array(MediaNodeSchema),
});
export type MediaDirectory = z.infer<typeof MediaDirectorySchema>;

export const MessageAttachmentDataSchema = z.object({
	id: z.string().uuid(),
	parentId: z.string().uuid().nullable(),
	kind: MediaTypeSchema,
	videoId: z.string().optional(),
	mimeType: z.string().optional(),
	filename: z.string(),
	createdAt: z.string(),
	updatedAt: z.string(),
	children: z.array(z.string().uuid()).optional(),
	contentSource: z.enum(['console', 'client']).default('console'),
});
export type MessageAttachmentData = z.infer<typeof MessageAttachmentDataSchema>;
export const MessageAttachmentsDataSchema = z.array(MessageAttachmentDataSchema).default([]);
export type MessageAttachmentsData = z.infer<typeof MessageAttachmentsDataSchema>;
